<template>
  <div class="costData">
    <div class="mainContentWrap">
      <el-row>
        <el-col :span="24">
          <div class="title">{{ projectName }}</div>
          <div class="unitClass">单位：元</div>
          <div class="top">
            <el-row>
              <el-col :span="10">
                <div class="top_sum">
                  总收入
                  <br />
                  {{ formatCurrency(sumData.earningAmount) }}
                </div>
                <div class="top_sum top_sum1">
                  毛利
                  <br />
                  {{ formatCurrency(sumData.grossProfitAmount) }}
                </div>
              </el-col>
              <el-col :span="14">
                <div class="echart1" id="echart43Top"></div>
              </el-col>
            </el-row>
          </div>
          <div class="middle">
            <div class="title">收入成本毛利分析柱状图</div>
            <div class="echarts2Wrap">
              <div class="echarts2Conents">
                <div class="echart2" id="echart43Center"></div>
                <div class="echart_legend">
                  <div>
                    <span>收入</span><span class="colorBox colorBox1"></span
                    ><span>{{ formatCurrency(sumData.earningAmount) }}</span>
                  </div>
                  <div>
                    <span>成本</span><span class="colorBox colorBox2"></span
                    ><span>{{ formatCurrency(sumData.costAmount) }}</span>
                  </div>
                  <div>
                    <span>毛利</span><span class="colorBox colorBox3"></span
                    ><span>{{
                      formatCurrency(sumData.grossProfitAmount)
                    }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="bottom">
                        <div class="title">回收趋势</div>
                        <div class="echart1" id="echart43bottom"></div>
                    </div> -->
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { getProfitCostAmountProject } from "@/services/dataCenterAService";

var echarts = require("echarts/lib/echarts");
// 引入柱状图
require("echarts/lib/chart/bar");
require("echarts/lib/chart/pie");
require("echarts/lib/chart/line");
// 引入提示框和标题组件
require("echarts/lib/component/tooltip");
require("echarts/lib/component/title");
export default {
  name: "costData",

  data() {
    return {
      //顶部数据
      projectName: "",
      sumData: {},
      //中间部分数据
      echart43MiddleRight: null,
      echart43MiddleLeft: null,
      echart43: null,
      echart43bottom: null,
    };
  },
  methods: {
    setWrapHeight() {
      let cww = document.getElementsByClassName("costTotalWrap")[0].offsetWidth;
      let ch = Math.ceil((1660 / 900) * cww * 0.98);
      if (document.getElementById("aside")) {
        ch = 1660;
        document.getElementsByClassName("costData")[0].style.width = "900px";
      }
      document.getElementsByClassName("costData")[0].style.height = ch + "px";

      if (this.echart43MiddleRight) {
        this.echart43MiddleRight.resize();
      }

      if (this.echart43MiddleLeft) {
        this.echart43MiddleLeft.resize();
      }

      if (this.echart43) {
        this.echart43.resize();
      }

      if (this.echart43bottom) {
        this.echart43bottom.resize();
      }
    },
    search(searchData) {
      let _this = this;
      //查询项目部下的数据

      //查询看板数据
      let params = {};
      if (searchData.yearMonth) {
        params.yearMonth = searchData.yearMonth;
      }
      if (searchData.projectProcess) {
        params.projectProcess = searchData.projectProcess;
      }
      if (searchData.deptId) {
        params.deptId = searchData.deptId;
      }
      if (searchData.projectId) {
        params.projectId = searchData.projectId;
      }
      getProfitCostAmountProject(params)
        .then((res) => {
          if (res.code === 10000000) {
            _this.projectName = searchData.projectName;
            //顶部部分数据
            _this.sumData = res.data;
            this.$nextTick(() => {
              let centerParams = {
                grossProfitAmount: _this.sumData.grossProfitAmount, //总毛利
                grossProfitPct: _this.sumData.grossProfitPct, //总毛利百分比
                costAmount: _this.sumData?.costAmount ?? 0, //总成本
                costPct: _this.sumData?.costPct ?? 0, //总成本百分比
                directCostAmount: _this.sumData.directCostAmount, //直接成本
                directCostPct: _this.sumData.directCostPct, //直接成本百分比
                inDirectCostAmount: _this.sumData.inDirectCostAmount, //间接成本
                inDirectCostPct: _this.sumData.inDirectCostPct, //间接成本百分比
              };
              // 中间部分数据
              _this.grossProfitProjectVOList = [];
              let param = res.data || {
                earningAmount: 0,
                costAmount: 0,
                grossProfitAmount: 0,
                costPct: "0",
                grossProfitPct: "0",
              };
              _this.grossProfitProjectVOList.push(param);
              // _this.grossProfitProjectVOList.unshift({});
              _this.echartsSumData = [[], [], []];
              _this.echartsSumDataName = [];
              // 中间柱状图
              _this.grossProfitProjectVOList.forEach((item, index) => {
                _this.echartsSumData[0].push(item.earningAmount);
                _this.echartsSumData[1].push(item.costAmount);
                _this.echartsSumData[2].push(item.grossProfitAmount);
                _this.echartsSumDataName.push(this.projectName);
              });
              this.draw(centerParams, "Top"); //顶部饼状图
              this.drawCenter(); //中间柱状图
            });
          } else if (res.code > 20000000) {
            this.$alert(res.msg, "提示", {
              confirmButtonText: "确定",
            });
          } else {
            this.$message.error("系统异常");
          }
        })
        .catch((error) => {
          this.$message.error("系统异常");
        });
    },
    //    绘制顶部饼状图
    draw(item, index) {
      let _this = this;
      console.log(index);
      let idName = "echart43" + index;
      // let myChart = echarts.init(document.getElementById(idName));
      this.echart43 = echarts.init(document.getElementById(idName));
      let option = {
        title: {
          show: false,
        },
        tooltip: {
          trigger: "item",
          showDelay: 20, // 显示延迟，添加显示延迟可以避免频繁切换，单位ms
          hideDelay: 20, // 隐藏延迟，单位ms
          textStyle: {
            fontSize: "16px",
            color: "#fff", // 设置文本颜色 默认#FFF
          },
          formatter: function (params) {
                  let txt = "";
                  txt =_this.getPecent(params.name, index);
                  return txt;
                },
        },
        legend: {
          orient: "horizontal",
          icon: "circle",
          bottom: 10,
          itemHeight: 5,
          itemWidth: 5,
          left: "center",
          data: ["毛利","直接成本", "间接成本"],
        },
        color: [ "#4EB2D4","#6DC8E1","#3F95C2"],
        series: [
          {
            name: "",
            type: "pie",
            radius: "67%",
            center: ["50%", "48%"],
            data: [
              { value: item.grossProfitAmount, name: "毛利" },
              { value: item.directCostAmount, name: "直接成本" },
              { value: item.inDirectCostAmount, name: "间接成本" },
              
            ],
            // 设置值域的那指向线
            labelLine: {
              normal: {
                show: false, // show设置线是否显示，默认为true，可选值：true ¦ false
              },
            },
            // 设置值域的标签
            label: {
              normal: {
                padding: [0, -20],
                textStyle: {
                  fontSize: 12,
                  color: "rgba(0,0,0,0.8)",
                },
                // formatter: "{b}\n{d}%"
                formatter: function (params) {
                  let txt = "";
                  txt =
                    params.name +
                    "\n" +
                    _this.getPecent(params.name, index) +
                    "\n" +
                    _this.formatCurrency(params.value);
                  return txt;
                },
              },
            },
          },
        ],
      };
      this.echart43.setOption(option);
    },

    //绘制中间柱状图
    drawCenter() {
      //先设置表格的宽度
      let wrapWidth =
        document.getElementsByClassName("echarts2Wrap")[0].offsetWidth;
      if (this.grossProfitProjectVOList.length * 150 + 200 < wrapWidth) {
        document.getElementsByClassName("echarts2Conents")[0].style.width =
          wrapWidth + "px";
      } else {
        let widthC = 200 + this.grossProfitProjectVOList.length * 150;
        document.getElementsByClassName("echarts2Conents")[0].style.width =
          widthC + "px";
      }

      this.echart43Center = echarts.init(
        document.getElementById("echart43Center")
      );
      let option = {
        legend: {
          // data: ["审计额或已完成产值", "已收款", "应收账款"],
          data: [],
          orient: "horizontal",
          bottom: 0,
          itemHeight: 0,
          itemWidth: 0,
          left: "center",
        },
        grid: {
          left: 150,
          right: 80,
          bottom: 0,
          top: 20,
          containLabel: true,
        },
        tooltip: {
          show: false,
        },
        color: ["#3F95C2", "#6DC8E1", "#4EB2D4"],
        xAxis: {
          show: false,
          data: this.echartsSumDataName,
          axisLine: {
            // 坐标轴 轴线
            show: false, // 是否显示
          },
          axisTick: {
            // 坐标轴的刻度
            show: false, // 是否显示
          },
          label: {
            show: false,
          },
        },
        yAxis: {
          show: true, // 是否显示
          type: "value", // 轴类型，默认为 ‘category’
          axisLine: {
            // 坐标轴 轴线
            show: false, // 是否显示
          },
          axisTick: {
            // 坐标轴的刻度
            show: false, // 是否显示
          },
          min: 0,
        },
        series: [
          {
            name: "收入",
            type: "bar",
            barWidth: 40, // 柱形的宽度
            data: this.echartsSumData[0],
          },
          {
            name: "成本",
            type: "bar",
            barWidth: 40, // 柱形的宽度
            data: this.echartsSumData[1],
          },
          {
            name: "毛利",
            type: "bar",
            barWidth: 40, // 柱形的宽度
            data: this.echartsSumData[2],
          },
        ],
      };
      this.echart43Center.setOption(option);
    },
    getPecent(name, index) {
      console.log(index);
      if (index == "Top") {
        switch (name) {
          case "毛利":
            return this.sumData.grossProfitPct;
         case "直接成本":
            return this.sumData.directCostPct;
          case "间接成本":
            return this.sumData.inDirectCostPct;
        }
      } else {
        switch (name) {
          case "毛利":
            return this.auditAmountDeptList[index - 1].grossProfitPct;
          case "直接成本":
            return this.auditAmountDeptList[index - 1].directCostPct;
          case "间接成本":
            return this.auditAmountDeptList[index - 1].inDirectCostPct;
        }
      }
    },
    //数字用逗号隔开
    formatCurrency(num) {
      num = Number(num);
      num = num.toFixed(2);
      if (num === 0) {
        return 0;
      } else if (num) {
        num = num.toString().replace(/\$|\,/g, "");
        if (num === "" || isNaN(num)) {
          return 0;
        }
        var sign = "";
        if (num.indexOf("-") !== -1) {
          sign = "-";
          num = num.substr(1);
        }
        var cents = num.indexOf(".") > 0 ? num.substr(num.indexOf(".")) : "";
        cents = cents.length > 1 ? cents : "";
        num = num.indexOf(".") > 0 ? num.substring(0, num.indexOf(".")) : num;
        if (cents === "") {
          if (num.length > 1 && num.substr(0, 1) === "0") {
            return 0;
          }
        } else {
          if (num.length > 1 && num.substr(0, 1) === "0") {
            return 0;
          }
        }
        for (var i = 0; i < Math.floor((num.length - (1 + i)) / 3); i++) {
          num =
            num.substring(0, num.length - (4 * i + 3)) +
            "," +
            num.substring(num.length - (4 * i + 3));
        }
        return sign + num + cents;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.costData {
  /*height: calc(100% - 65px);*/
  /*text-align: left;*/
  /*!*overflow: hidden;*!*/
  /*background: #ffffff;*/
  /*padding:  0 10px;*/

  width: 98%;
  text-align: left;
  overflow: hidden;
  background: #ffffff;
  padding: 0 10px;
  height: 1660px;
  margin: 0 auto;

  .mainContentWrap {
    height: 99%;
    /*overflow: auto;*/
    /*height: calc(100% - 100px);*/
    /*height: 100%;*/
    .el-row {
      /*height: calc(100% - 50px);*/
      height: 100%;

      .el-col {
        height: 100%;

        .title {
          text-align: center;
          font-size: 24px;
          line-height: 50px;
          font-weight: 600;
        }

        .unitClass {
          text-align: right;
          font-size: 20px;
        }

        .top {
          width: calc(100% - 10px);
          border: 1px solid #c8c8c8;
          /*height: 280px;*/
          height: 17%;
          padding-top: 6px;
          margin: 5px;

          .el-row {
            height: 100%;

            .el-col {
              height: 100%;

              .top_sum {
                text-align: center;
                height: 40%;
                font-size: 16px;
                font-weight: 600;
                line-height: 10px;
                background: #6dc8e1;
                width: 80%;
                margin: 2% auto 3%;
              }

              .top_sum1 {
                background: #4eb2d4;
                margin: 0 auto;
              }

              .top_sum::before {
                display: inline-block;
                content: "";
                height: 60%;
                vertical-align: middle;
              }

              .echart1 {
                height: 100%;
              }
            }
          }
        }

        .middle {
          width: calc(100% - 10px);
          border: 1px solid #c8c8c8;
          /*height: calc(46% - 10px);*/
          /*height: 512;*/
          height: 38%;
          margin: 10px 5px;
          position: relative;

          .title {
            text-align: left;
            font-weight: 600;
            font-size: 16px;
            line-height: 16px;
            margin: 10px 0 0px 10px;
          }

          .echarts2Wrap {
            height: calc(100% - 26px);
            width: 100%;
            overflow-x: auto;
            overflow-y: hidden;
            .echarts2Conents {
              display: flex;
              height: 100%;
              .echart2 {
                width: 70%;
                height: calc(100% - 124px - 32px);
                margin-top: 40px;
              }

              .echart_legend {
                // text-align: center;
                // position: absolute;
                // right: 20px;
                // width: 100%;
                flex: 1;
                display: flex;
                flex-direction: column;
                justify-content: center;
                height: 100%;
                line-height: 30px;
                .colorBox {
                  display: inline-block;
                  margin-right: 2px;
                  width: 18px;
                  height: 10px;
                  border-radius: 3px;
                  margin: 0 10px;
                }
                .colorBox1 {
                  background: #3f95c2;
                }
                .colorBox2 {
                  background: #6dc8e1;
                }
                .colorBox3 {
                  background: #4eb2d4;
                }
              }
            }
          }

          .centerTable {
            /*position: absolute;*/
            /*width: calc(100% - 118px);*/
            /*top: 64%;*/
            /*left: 40px;*/
            padding: 0 80px 0 90px;
            overflow: hidden;

            /deep/ .el-table {
              overflow: hidden;
            }

            /deep/ .el-table tr {
              th {
                padding: 0;
                background: #ffffff;

                .cell {
                  text-align: center;
                  height: 30px;
                  line-height: 30px;
                  /*overflow: auto;*/
                  overflow: hidden; /*设置超出的部分进行影藏*/
                  text-overflow: ellipsis; /*设置超出部分使用省略号*/
                  white-space: nowrap; /*设置为单行*/
                  width: 100%;
                }
              }

              td {
                padding: 0;

                .cell {
                  text-align: center;
                  height: 30px;
                  line-height: 30px;
                  padding-left: 0px;

                  .tableSpan {
                    display: inline-block;
                    margin-right: 2px;
                    width: 8px;
                    height: 8px;
                    border-radius: 2px;
                  }
                }
              }

              td:nth-of-type(1) .cell {
                text-align: left;
              }
            }
          }
        }
        .bottom {
          width: calc(100% - 10px);
          border: 1px solid #c8c8c8;
          /*height: 510px;*/
          height: 31%;
          margin: 5px;

          .title {
            text-align: left;
            font-size: 16px;
            line-height: 16px;
            margin: 10px 0 10px 10px;
          }

          .echart1 {
            height: calc(100% - 36px);
          }
        }
      }
    }
  }
}
</style>

